// extracted by mini-css-extract-plugin
module.exports = {"marketColumn":"Markets_marketColumn__2UbyJ","outcomesTable":"Markets_outcomesTable__3QI-q"};